export const contactsData = {
    email: 'swapnalidukhande98@gmail.com',
    phone: '+918779780168',
    address: 'Lower Parel, Mumbai',

    sheetAPI: 'https://sheetdb.io/api/v1/391o3e4sfgfs2'
}